<template>
  <modal name="modal-add-contact" height="auto" :width="560"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>{{ member?'EDIT':'ADD' }} CONTACT</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doSave">

        <div class="form-group" v-if="!clientId">
          <label>COMPANY</label>
          <input v-if="companyMethod == 'new'" v-model="client_name" type="text" class="form-control" placeholder="Enter Company Name">
          <div v-else class="d-flex justify-content-between">
            <v-select v-model="client_id" :options="clients" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true"  placeholder="- Select"></v-select>
            <span style="width: 10%;text-align: center;">or</span>
            <button type="button" class="btn btn-outline-black" style="width: 45%;"
                    @click="companyMethod = 'new'">Add New</button>
          </div>
        </div>
        <div class="form-group" v-if="!clientId && companyMethod == 'new'">
          <label>CLIENT OR SUPPLIER</label>
          <v-select v-model="client_is_supplier" :options="[{value: '0', label: 'Client'},{value: '1', label: 'Supplier'}]" class="form-control" placeholder="- Select"></v-select>
        </div>

        <div class="row">
          <div class="form-group col">
            <label for="first_name">First Name <span class="text-danger">*</span></label>
            <input type="text" name="first_name" id="first_name" ref="inputName"
                   :class="{'form-control': true, 'is-invalid': errors.has('first_name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.first_name">
            <div class="invalid-feedback">{{ errors.first('first_name') }}</div>
          </div>
          <div class="form-group col">
            <label for="last_name">Last Name <span class="text-danger">*</span></label>
            <input type="text" name="last_name" id="last_name"
                   :class="{'form-control': true, 'is-invalid': errors.has('last_name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.last_name">
            <div class="invalid-feedback">{{ errors.first('last_name') }}</div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col">
            <label for="role">Role/Position</label>
            <input type="text" name="role" id="role" v-model="postData.role" class="form-control">
          </div>

          <div class="form-group col">
            <label for="phone">Phone</label>
            <input type="text" name="phone" id="phone" v-model="postData.phone" class="form-control">
          </div>
        </div>

        <div class="form-group">
          <label for="email">Email Address <span class="text-danger">*</span></label>
          <input type="text" name="email" id="email"
                 :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.email">
          <div class="invalid-feedback">{{ errors.first('email') }}</div>
        </div>

        <div class="form-group">
          <label>Notes</label>
          <textarea-autosize v-model="postData.note" :min-height="50" :max-height="200" class="form-control" placeholder=""></textarea-autosize>
        </div>

        <div class="row">
          <div class="form-group col">
            <label for="password">Password</label>
            <input type="password" name="password" id="password" class="form-control" v-model="postData.password">
          </div>
          <div class="form-group col">
            <label for="password_confirmation">Retype Password</label>
            <input type="password" name="password_confirmation" id="password_confirmation" class="form-control" v-model="postData.password_confirmation">
          </div>
        </div>

        <div class="custom-control custom-checkbox mb-2">
          <input type="checkbox" class="custom-control-input" id="is_manager" v-model="postData.is_manager">
          <label class="custom-control-label" for="is_manager">Set as manager account</label>
        </div>

        <div class="pt-2 mb-3 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import ServiceClient from '@/services/client'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: '',
      postData: false,
      client_id: '',
      client_name: '',
      client_is_supplier: 0,
      companyMethod: ''
    }
  },
  props: ['value', 'clients', 'member', 'clientId'],
  computed: mapState({
    client: state => state.client.client
  }),
  watch: {
    member: 'init',
    clientId: 'init',
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.$modal.show('modal-add-contact', {});
        setTimeout(() => {
          self.$refs.inputName.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.resetForm();
      if ( !self.member ) {
        return;
      }
      for(let field in self.postData){
        if(typeof self.member[field] != "undefined"){
          self.postData[field] = self.member[field];
        }
      }
      self.postData.password = '';
      self.postData.password_confirmation = '';
    },
    resetForm () {
      let self = this;
      self.postData = {
        first_name: '',
        last_name: '',
        email: '',
        role: '',
        phone: '',
        note: '',
        password: '',
        password_confirmation: '',
        send_welcome: true,
        is_manager: false,
      };
      self.client_id = typeof self.clientId != 'undefined'  && self.clientId? self.clientId : '';
    },
    closeModal () {
      this.companyMethod = '';
      this.$modal.hide('modal-add-contact');
    },
    doSave ( ) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      if (!self.client_id && self.companyMethod != 'new') {
        self.$notify({
          type: 'error',
          text: 'Please select the Company'
        });
        return;
      }

      if (!self.postData.email) {
        self.$notify({
          type: 'error',
          text: 'Please select the email'
        });
        return;
      }

      let updateData = {};
      if ( !self.member ) {
        updateData = self.postData;
      }else{
        for(let field in self.member){
          if (typeof self.postData[field] != 'undefined' && self.postData[field] != self.member[field] )
            updateData[field] = self.postData[field];
        }
      }

      if ( self.postData.password ){
        if (self.postData.password != self.postData.password_confirmation) {
          self.$notify({
            type: 'error',
            text: 'Password and password confirmation does not match!'
          });
          return false;
        }
        updateData.password = self.postData.password;
        updateData.password_confirmation = self.postData.password_confirmation;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            if ( self.member ){
              ServiceClient.saveMember(self.client_id, self.member.id, updateData, member => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Contact updated successfully.'
                });
                self.resetForm();
                self.$emit('contact-saved', member);
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }else{
              if (self.companyMethod == 'new') {
                updateData.client_name = self.client_name;
                updateData.client_is_supplier = self.client_is_supplier;
              }
              ServiceClient.createMember(self.client_id?self.client_id:-1, updateData, member => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'New contact added successfully.'
                });
                self.resetForm();
                self.$emit('contact-saved', member);
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }
          }
        });
    }
  }
}
</script>
